import { Component } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface TabFieldProps extends FormlyFieldProps {
  scrollable?: boolean;
}

@Component({
  selector: 'tab-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Tabs, Tab, TabList, TabPanel, TabPanels, ButtonModule],
  template: `

  <p-tabs [value]="field.key+'-0'"  [scrollable]="props.scrollable ?? false">
  <p-tablist>
  @for (
        step of field.fieldGroup;
        track step;
        let index = $index;
        let first = $first, last = $last
      ) {
      <p-tab
        [value]="field.key+'-'+index"
      >
      <div class="flex gap-2 flex-col items-center">
              <span
                class="{{
                  !isValid(step)
                    ? 'text-[var(--p-form-field-invalid-placeholder-color)] italic'
                    : ''
                }}"
                >{{ step.props?.label }}</span
              >
      </div>
    </p-tab>
      }
      </p-tablist>
    <p-tabpanels>
    @for (
        step of field.fieldGroup;
        track step;
        let index = $index;
        let first = $first, last = $last
      ) {
      <p-tabpanel [value]="field.key+'-'+index">
        <div class="mb-2">
        <small
                class="text-[var(--p-form-field-invalid-placeholder-color)] italic w-full"
              >
                <formly-validation-message
                  class="ui-message-text"
                  [field]="step"
                ></formly-validation-message>
              </small>
        </div>
      <formly-field [field]="step"></formly-field>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>

  `,
})
export class TabFieldType extends FieldType<
  FieldTypeConfig<TabFieldProps>
> {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.valid;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isValid(f))
      : true;
  }

  isDirty(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.dirty;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isDirty(f))
      : true;
  }
  isTouched(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl!.touched;
    }

    return field.fieldGroup
      ? field.fieldGroup.every((f) => this.isTouched(f))
      : true;
  }
}
